// extracted by mini-css-extract-plugin
module.exports = {"detailsRightWrapper":"styles_detailsRightWrapper__YVxqA","primaryID":"styles_primaryID__46hda"};